export default __webpack_public_path__ + "static/media/avasta.d2283eda.woff2";